// Description: Colors for the application
export default {
  transparent: 'transparent',
  black: '#171C29',
  white: '#FFF',
  text: '#1B1B1B',
  cta: {
    light: '#e02424',
    default: '#C20000',
  },
  link: {
    default: '#DD0000'
  },
  'resource-blog': {
    'article-tag-text': '#2195F3',
    'article-tag-body': '#E4F2FD',
    'video-tag-text': '#d721f3',
    'video-tag-body': '#e98dfa',
    'podcast-tag-text': '#1a7e00',
    'podcast-tag-body': '#a1e194',
  },
  primary: {
    lightest: "#E7F4FD",
    lighter: "#2FAEF6",
    light: "#63A2EA",
    default: "#0D7AD9",
    dark: "#2A7CAA",
    darker: "#15618B",
    darkest: "#052B40",
  },
  secondary: {
    lightest: "#E7F4FD",
    lighter: "#2FAEF6",
    light: "#63A2EA",
    default: "#0D7AD9",
    dark: "#2A7CAA",
    darker: "#15618B",
    darkest: "#052B40",
  },
  accent: {
    light: '#e3d493',
    default: '#c9a400',
    dark: '#594d18',
  },
  gray: {
    50: '#F6F7FC',
    100: '#F1F3F8',
    200: '#E7EAF0',
    300: '#DDE1EA',
    400: '#CBCED7',
    500: '#66666F',
    600: '#767C8D',
    700: '#5D6375',
    800: '#3E3F40',
    900: '#232325',
  },
  success: {
    lightest: '#C9FBCE',
    lighter: '#A7EBC2',
    light: '#98CFD0',
    default: '#089B81',
    dark: '#065546',
    darker: '#10542B',
  },
  warning: {
    lightest: '#FFF3D3',
    lighter: '#CD9701',
    light: '#cc733f',
    default: '#AA5A2D',
    dark: '#AA5A2D',
    darker: '#AA5A2D',
    darkest: '#AA5A2D',
  },
  danger: {
    lightest: '#FEDEDE',
    lighter: '#F2C8D7',
    light: '#FAB637',
    default: '#CA3A31',
    dark: '#C9235F',
    darker: '#A82727',
    darkest: '#853423',
  },

}
